import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiClock, FiMapPin, FiFacebook } = FiIcons;

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <Link to='/'>
                <img className='h-12 object-contain' src='/img/logo-cleaning.png'></img>
              </Link>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Professional commercial and domestic cleaning services across Buckinghamshire. Reliable, trustworthy, and thorough cleaning solutions for your property.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Information</h4>
            <div className="space-y-4">
              <a
                href="tel:07878522378"
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors"
              >
                <SafeIcon icon={FiPhone} className="w-5 h-5" />
                <span>07878 522378</span>
              </a>
              <div className="flex items-start space-x-3 text-gray-400">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 mt-1" />
                <div>
                  <p>5 Ossulbury Lane</p>
                  <p>Aylesbury HP19 9DW</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Opening Hours</h4>
            <div className="flex items-start space-x-3 text-gray-400">
              <SafeIcon icon={FiClock} className="w-5 h-5 mt-1" />
              <div>
                <p className="font-medium">Monday - Sunday</p>
                <p>9:00 AM - 8:00 PM</p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Follow Us</h4>
            <div className="flex space-x-4">
              <a
                href="https://share.google/xr3mZOVXjGPtaFHeP"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                aria-label="Google Reviews"
              >
                <span className="text-white font-bold text-sm">G</span>
              </a>
              <a
                href="https://www.facebook.com/aylesburycleaner/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
                aria-label="Facebook"
              >
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Diamond Cleaning Aylesbury. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                to="/privacy"
                onClick={handleLinkClick}
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                onClick={handleLinkClick}
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;